module.exports = __webpack_public_path__ + "static/media/1.152d4285.svg";